/**
 * Создание уникального UUID
 */
export function createUUID () {
  const hexDigits = '0123456789abcdef'
  const uuidArray = []
  for (let i = 0; i < 36; i++) {
    if ([8, 13, 18, 23].includes(i)) {
      uuidArray[i] = '-'
    } else if (i === 14) {
      uuidArray[i] = '4'
    } else if (i === 19) {
      const randomHex = Math.floor(Math.random() * 16)
      const variant = (randomHex & 0x3) | 0x8
      uuidArray[i] = hexDigits[variant]
    } else {
      uuidArray[i] = hexDigits[Math.floor(Math.random() * 16)]
    }
  }
  return uuidArray.join('')
}

/**
 * Throttle позволяет ограничить выполнение функции так, чтобы она выполнялась не чаще чем через заданный интервал времени.
 * @param func
 * @param limit - Как только функция была вызвана, она не будет вызвана снова до окончания заданного периода времени.
 * @returns {(function(): void)|*}
 */
export function throttle (func, limit) {
  let inThrottle
  return function () {
    const args = arguments
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}

/**
 * Debounce обеспечивает задержку выполнения функции до тех пор, пока событие не прекратится.
 * @param func
 * @param delay - Функция будет вызвана только после того, как прошло заданное время с момента последнего вызова.
 * @returns {(function(): void)|*}
 */
export function debounce (func, delay) {
  let debounceTimer
  return function () {
    const context = this
    const args = arguments
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => func.apply(context, args), delay)
  }
}
